import { render, staticRenderFns } from "./HotelSearchResult.vue?vue&type=template&id=48268d1c&scoped=true"
import script from "./HotelSearchResult.vue?vue&type=script&lang=js"
export * from "./HotelSearchResult.vue?vue&type=script&lang=js"
import style0 from "./HotelSearchResult.vue?vue&type=style&index=0&id=48268d1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48268d1c",
  null
  
)

export default component.exports